module.exports = __webpack_public_path__ + "assets/img/plan6-1.5d91c88b.png";